import React from 'react';
import UnknownDumbView from '../../../../DeviationViews/Dumbo/Unknown';
import s from './Unknown.scss';
var UnknownThumbReactView = function (_a) {
    var width = _a.width, height = _a.height, deviation = _a.deviation;
    return (React.createElement("div", { className: s['root'] },
        React.createElement(UnknownDumbView, { width: width, height: height, deviation: deviation })));
};
UnknownThumbReactView.displayName = 'UnknownThumbReactView';
export default UnknownThumbReactView;
//# sourceMappingURL=Unknown.js.map